import React, { useContext, useEffect } from "react";
import { usePublicUserAuthModal } from "../../Authentication/Public/PublicUserAuthModal";
import { AuthContext } from "../../Authorization/AuthContext";
import Layout from "../Layout";

const LoginRequiredPage = () => {
  const [showPublicUserLoginModal] = usePublicUserAuthModal();

  useEffect(() => {
    showPublicUserLoginModal();
  }, [showPublicUserLoginModal]);

  return <Layout hasGutters={true}>{null}</Layout>;
};

export const withPublicUserAuth = <P extends {}>(
  WrappedComponent: React.ComponentType<P>,
  _resource: string,
) => {
  return (props: P) => {
    const { publicUser } = useContext(AuthContext);

    if (!publicUser) {
      return <LoginRequiredPage />;
    }

    return <WrappedComponent {...props} />;
  };
};
